<app-calendario [titulo]="tituloMes" [diasDaSemana]="diasDaSemana" (mudarMes)="mudarMes($event)">
    <div
      class="calendario-dia"
      *ngFor="let dia of dias; trackBy: rastrearDia"
      [class.calendario-dia--outro-mes]="!dia.pertenceAoMes"
      [class.calendario-dia--hoje]="ehHoje(dia)"
      role="gridcell">
      <div class="calendario-dia__cabecalho">
        <span class="calendario-dia__numero">{{ dia.data.getDate() }}</span>
      </div>
      <div class="calendario-dia__logs">
        <span
          *ngFor="let log of logsDoDia(dia); trackBy: rastrearLog"
          class="ponto-tag"
          [class.ponto-tag--simulacao]="ehSimulacao(log)"
          [class.ponto-tag--erro]="!log.blSucesso">
          {{ obterTextoTag(log) }}
        </span>
      </div>
    </div>
</app-calendario>
